/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import {Component} from 'vue-property-decorator'
import Vue from 'vue'
import {namespace} from 'vuex-class'
import {
  MAINTENANCE_MODULE_NAMESPACE
} from '../../../store/maintenance'
import {MaintenanceService} from '../../../services'
import { DateTimeHelper } from '../../../utils/DateTimeHelper.util'
import {eventBus} from '../../../main'

const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)

@Component({
  components: {
    'document-modal-vertical': async () => import('../../documents/components/document-modal-vertical/DocumentModalVertical.vue'),
    'timeline-history': async () => import('./components/TimeLineHistoryChange.vue')
  }
})
class BlockMaintenanceDetail extends Vue {


  MaintenanceService: MaintenanceService
  maintenance:any
  actions:any[]
  dtActionOpen:boolean
  dtRequestModal: { visible: boolean, type: string | null, icon?: string, actionName?: string, translationKey?: string };
  dtFileUploading: boolean;
  ascending:boolean

  constructor() {
    super()
    this.MaintenanceService = new MaintenanceService()
    this.maintenance = null
    this.actions = []
    this.dtActionOpen = false
    this.dtRequestModal = { visible: false, type: null };
    this.dtFileUploading = false;
    this.ascending = false

  }


  // ============ MODALS
  attachDocs()
  {
    this.dtActionOpen = false
    this.dtRequestModal.type = 'attach_file'
    this.dtRequestModal.icon = 'attach_file'
    this.dtRequestModal.translationKey = 'DOCUMENT_ADD'
    this.dtRequestModal.visible = true
  }

  get coIcon(): string {
    return this.dtRequestModal.type && this.dtRequestModal.icon;
  }

  get buttonLoading(): boolean {
    return this.dtFileUploading === true;
  }
  handleRecord(event) {
    switch (this.dtRequestModal.type) {
      case 'attach_file':
        console.log('attach file')
        eventBus.$emit('DOC_SAVE_FILES_ATTRIBUTES')
        this.dtFileUploading = true;
        const docs = this.$store.state.document.document
        let payload = {sharing_type:[], files:[]}
        docs.attachments.forEach((doc, index)=>payload.files.push({
          type: doc.type,
          name: doc.name,
          file: doc.file,
          fk_attachment_type: docs.type,
          fk_attachment_type_level_2: docs.typeLvl2,
          reference: doc.reference,
          attributes: doc.attributes
        }))

        this.MaintenanceService.postMaintenanceAction(this.$route.params.cid,payload).then(data=>{
          eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
          this.$store.commit('document/DOCUMENT_SET_DOCUMENT',{
            attachments:[],
            share:[],
            type:null,
            typeLvl2:null,
          })
          this.dtFileUploading = false;
          this.dtRequestModal.visible = false
          this.getMaintenanceAndActions()
        })
      break;
    }
  }
  // ============ End modals




  get lblSetting () {
    return {
      ...require('@/locales/equipment').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/block').default,
      ...require('@/locales/agency-management').default,
      ...require('@/locales/button').default
    }
  }


  get textConfigs () {
    return require('@/assets/json-resources/text-field-configs.json')
  }


  get sortedActions ()
  {
    return this.actions.sort((a:{updatedAt:string},b:{updatedAt:string})=>{
      return new Date(b.updatedAt).valueOf() - new Date(a.updatedAt).valueOf();
    })
  }


  getMaintenanceAndActions()
  {
    this.maintenance = null
    this.actions = []
    this.MaintenanceService.getMaintenance(this.$route.params.cid).then(data=>{
      this.maintenance = data
    })

    this.MaintenanceService.getMaintenanceActions(this.$route.params.cid).then(data=>{
      this.actions = data
    })
  }


  mounted () {
    eventBus.$on('RELOAD_MAINTENANCE_AFTER_UPDATE',(updatedMaintenance)=>{
      this.getMaintenanceAndActions()
    })
    this.getMaintenanceAndActions()
  }

  beforeDestroy()
  {
    eventBus.$off('RELOAD_MAINTENANCE_AFTER_UPDATE')
  }

  editMaintenance()
  {
    eventBus.$emit('OPEN_MAINTENANCE_MODAL',{edit:true,maintenance:this.maintenance})
    this.dtActionOpen = false
  }

  get category()
  {
    if(!this.maintenance) return null
    return this.maintenance.equipment.category.name
  }

  get subCategory()
  {
    if(!this.maintenance.equipment.subcategory) return null
    return this.maintenance.equipment.subcategory.name
  }

  get equipmentName()
  {
    if(!this.maintenance) return null
    return this.maintenance.equipment.name
  }

  get equipmentRef()
  {
    if(!this.maintenance) return null
    return this.maintenance.equipment.reference
  }

  get maintenanceName()
  {
    if(!this.maintenance) return null
    return this.maintenance.name
  }

  get maintenanceDescription()
  {
    if(!this.maintenance) return null
    return this.maintenance.description
  }

  get createdAt()
  {
    if(!this.maintenance) return null
    return this.maintenance.createdAt
  }

  get manager()
  {
    if(!this.maintenance) return null
    let name = (`${this.maintenance.manager_assigned.firstname} ${this.maintenance.manager_assigned.lastname}`).trim()
    let role = this.maintenance.manager_assigned.role
    return {name,role}
  }

  get contractor()
  {
    if(!this.maintenance) return null
    let name = (`${this.maintenance.contractor.firstname} ${this.maintenance.contractor.lastname}`).trim()
    let role = this.maintenance.contractor.role
    return {name,role}
  }

  get creator()
  {
    if(!this.maintenance) return null
    let name = (`${this.maintenance.creator.firstname} ${this.maintenance.creator.lastname}`).trim()
    let role = this.maintenance.creator.role
    return {name,role}
  }

  getInitial(name:string):string {
    if(!this.maintenance) return null
    let initial = ""
    const split = name.split(" ")
    split.forEach(n=>initial += n.substring(0,1))
    return initial.toLocaleUpperCase()
  }

  pasreDate(date:string)
  {
    if(!date) return null
    return DateTimeHelper.parseDateWithoutTimezone(new Date(date))
  }

  pasreTime(date:string)
  {
    if(!date) return null
    return DateTimeHelper.parseTime(new Date(date))
  }


  get actionIcons () {
    return {
      create_maintenance:'engineering',
      update_maintenance:'update',
      update_attribute:'tune',
      done_maintenance:'done_all',
      update_equipment:'construction',
      alert_triggered:'campaign',
      ticket_created:'textsms',
      add_attachment:'attach_file',
      enable_maintenance:'alarm_on',
      disable_maintenance:'update_disabled',
      up_name_maintenance:'drive_file_rename_outline',
      up_description_maintenance:'description',
      up_contractor_maintenance:'person_add',
      waiting_maintenance:'hourglass_empty',
      up_manager_maintenance:'admin_panel_settings',
      ticket_closed:'event_busy',
      maintenance_archived:'move_to_inbox'
    }
  }

  getActionTitle(item)
  {
    switch(item.action_type){
      case 'update_attribute':
        return `L'attribut ${item.equipment_attribute_value.attribute.name} à été mis à jours`
      default:
        return item.action_label
    }
  }

  getActionCreator(entity)
  {
    return (`${entity.firstname} ${entity.lastname}`).trim()
  }

  getActionCreatorRole(entity)
  {
    return (`${entity.role}`).trim()
  }

  showDivider(action:string)
  {
    const actions:any = [
      'add_attachment',
      'ticket_created',
      'up_contractor_maintenance',
      'up_manager_maintenance',
      'up_name_maintenance',
      'up_description_maintenance',
      'update_attribute'
    ]

    return actions.includes(action)
  }

  handleBeforeClose(){}

  toggleMaintenanceState()
  {
    let newState = ''
    this.maintenance.state === 'enabled' || this.maintenance.state === 'waiting' ? newState = 'disabled' : newState = 'enabled'
    this.MaintenanceService.patchMaintenance(this.$route.params.cid,{state:newState}).then(data=>{
      this.getMaintenanceAndActions()
    })
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }

  get canAUpdateMaintenance () {
    if(this.isServiceBook)
    {
      return this.$route.meta['edit_maintenance'] || false
    } else {
      if (!localStorage.getItem('block_maintenance_details')) return false
      return JSON.parse(localStorage.getItem('block_maintenance_details')).edit_maintenance || false
    }
  }

  get canEdit(){
    return this.maintenance.state !=='archived' && this.canAUpdateMaintenance
  }

  get canAttachFile()
  {
    return this.maintenance.state !=='archived' && this.maintenance.state !=='done'
  }

}

export default BlockMaintenanceDetail



// WEBPACK FOOTER //
// ./src/containers/block/block-maintenance-detail/index.ts